import { useMutation } from '@tanstack/react-query';
import { Tag } from 'src/models';
import { ambientApi } from 'src/services';

export type UseTagEncounterMutationPayload = {
  encounterId: string;
  tag: Tag;
};

export type UseUntagEncounterMutationPayload = UseTagEncounterMutationPayload;

export const useTagEncounter = () => {
  return useMutation({
    mutationKey: ['tagEncounter'],
    mutationFn: ({ encounterId, tag }: UseTagEncounterMutationPayload) => {
      return ambientApi.post(`/encounters/${encounterId}/tag`, {
        tag_id: tag.id,
      });
    },
  });
};

export const useUntagEncounter = () => {
  return useMutation({
    mutationKey: ['untagEncounter'],
    mutationFn: ({ encounterId, tag }: UseUntagEncounterMutationPayload) => {
      return ambientApi.delete(`/encounters/${encounterId}/tag`, {
        data: {
          tag_id: tag.id,
        },
      });
    },
  });
};
